import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "@/index.css";
import "@/i18n";  // i18next bootstrap — must run before App mounts (§1.48)
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import { register as registerServiceWorker } from "@/lib/serviceWorkerRegistration";

// Initialise Sentry before React mounts so render errors during App boot
// also get captured. No-op when REACT_APP_SENTRY_DSN is unset.
initSentry();

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

// PWA install — registers /service-worker.js after window load (no-op
// in dev / when REACT_APP_DISABLE_SW=true). KNOWN_ISSUES §1.43.
registerServiceWorker();
